import React from "react"

import {
  CircleAlertIcon,
  ClipboardListIcon,
  FolderKanbanIcon,
  UsersIcon
} from "../home-icons.tsx"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { LEAD_STATUSES } from "../../../Lead/constants/lead-statuses.ts"
import { type PermissionFeatures } from "../../../SettingsPermissions/types/permissions.types.ts"
import type { DashboardStats as DashboardStatsType } from "../../types/types.ts"

export type DashboardStatType = "projects" | "checklists" | "invoices" | "leads"

export interface DashboardStatItemConfig {
  key: DashboardStatType
  icon: React.ReactNode
  iconBg: string
  iconColor: string
  title: string
  metric: keyof DashboardStatsType
  format: (value: number) => string
  href?: string
  isVisible: (permissionFeatures: PermissionFeatures) => boolean
}

export const readStatValue = (
  data: DashboardStatsType | null,
  stat: DashboardStatItemConfig
): string | null => {
  const value = data?.[stat.metric]
  return typeof value === "number" ? stat.format(value) : null
}

const DASHBOARD_STATS_ITEMS: DashboardStatItemConfig[] = [
  {
    key: "projects",
    icon: <FolderKanbanIcon width={20} height={20} />,
    iconBg: "#DDF5F6",
    iconColor: "#00879B",
    title: "Projects",
    metric: "active_projects",
    format: (value) => `${value} Active`,
    href: RoutesPaths.project.grid,
    isVisible: (codes) => !!codes?.projects?.projects?.project_view
  },
  {
    key: "checklists",
    icon: <ClipboardListIcon width={20} height={20} />,
    iconBg: "#FFF2DF",
    iconColor: "#FF9800",
    title: "Checklist Items",
    metric: "pending_checklists",
    format: (value) => `${value} pending`,
    isVisible: (codes) => !!codes?.projects?.checklists?.project_checklist_view
  },
  {
    key: "invoices",
    icon: <CircleAlertIcon width={20} height={20} />,
    iconBg: "#FFE8EB",
    iconColor: "#FF304B",
    title: "Overdue Invoices",
    metric: "overdue_invoices",
    format: (value) => `${value} Invoices`,
    isVisible: (codes) => !!codes?.projects?.invoices?.project_invoice_view
  },
  {
    key: "leads",
    icon: <UsersIcon width={20} height={20} />,
    iconBg: "#E5F0FF",
    iconColor: "#0062D6",
    title: "Leads",
    metric: "new_leads",
    format: (value) => `${value} New Leads`,
    href: `${RoutesPaths.lead.list}?status=${LEAD_STATUSES.NEW}`,
    isVisible: (codes) => !!codes?.leads?.leads?.lead_view
  }
]

export { DASHBOARD_STATS_ITEMS }
